import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VuetifyDialog from "vuetify-dialog";
import axios from 'axios';
import DatetimePicker from 'vuetify-datetime-picker'
import VueSignaturePad from 'vue-signature-pad';
import { VueMaskDirective } from 'v-mask'
import VueSweetalert2 from 'vue-sweetalert2';
import { ValidationProvider } from 'vee-validate';
import './registerServiceWorker'
import VueHead from 'vue-head'

import VueGeolocation from 'vue-browser-geolocation'
import '@whoicd/icd11ect/style.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '../utils/validation'
import DateTimeUtil from '../utils/date-time.util';

//option Menu
import OptionMenu from "@/components/OptionMenu";

Vue.use(VueHead)
Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(DatetimePicker);
Vue.use(VueSignaturePad);
Vue.use(VueGeolocation);
Vue.use(VueSweetalert2);
Vue.use(VuetifyDialog);
Vue.component('ValidationProvider', ValidationProvider);

Vue.directive('mask', VueMaskDirective);
Vue.prototype.$http = axios;

Vue.use
Vue.prototype.$http = axios;
const token = localStorage.getItem("token");

//if there is a token, default axios authorization headers
if(token){
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

/**
 * Define global (template) filters here.
 * It’s worth noting that filters can only be used in mustache and binding expressions ({{thing | filter}} and :prop=“thing | filter”).
 * Unlike Angular, they can’t be used in v-if or v-for.
 */
Vue.filter('toLocalDate', DateTimeUtil.toLocalDate);
Vue.filter('toLocalDateTime', DateTimeUtil.toLocalDateTime);
Vue.filter('formattedDate', DateTimeUtil.formattedDate);

//register option menu as global component
Vue.component('OptionMenu', OptionMenu);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
